export const SHOW_CUSTOM_POLARS_ACCESS = false;
export const SHOW_BOAT_POLARS_EDITOR = true;
export const SHOW_SEGMENT_LABELS = false;
export const SHOW_MAP_HIGHLIGHT_SEGMENT = true;
export const SHOW_MANUAL_SEGMENT_TOOLS = false;
